import React from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../constants/text';
import { smallerThanOrEqualTo } from '../../../core/util/styledComponents';
import PrivacyPolicy from '../../LegalLinks/PrivacyPolicy';
import TermsOfService from '../../LegalLinks/TermsOfService';
import ResponsibleDisclosure from '../../LegalLinks/ResponsibleDisclosure';

const StyledLinks = styled.div`
  text-align: left;

  ${smallerThanOrEqualTo.sm`
    display: flex;
    flex-direction: column;
  `}

  a {
    cursor: pointer;
    color: white !important;
    font-family: ${fontFamily.book}!important;
    -webkit-font-smoothing: antialiased;
    line-height: 18px;
    font-size: ${fontSize.small};

    ${smallerThanOrEqualTo.sm`
      margin-bottom: 7px;
    `}
  }
`;

type Props = {
  className?: string;
  showHIPAAAuthorization?: boolean;
};

const PrivacyLinks = (props: Props) => {
  const { className, showHIPAAAuthorization = true } = props;
  return (
    <StyledLinks className={className}>
      <PrivacyPolicy />
      <TermsOfService />
      <ResponsibleDisclosure />
    </StyledLinks>
  );
};

export default PrivacyLinks;
